import Content from "../../common/Content";
import Button from "../../ui/Button";
import { ReactComponent as ArrowRight } from "../../../assets/icons/arrow-right.svg";
import DifficultySelector from "../../ui/DifficultySelector";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import GameArea from "../../ui/GameArea";
import PlayButton from "../../ui/PlayButton";
import FingerSkillsLevel from "../FingerSkills/FingerSkillsLevel";
import ContentCenter from "../../ui/ContentCenter";
import ArmsUpLevel from "../ArmsUp/ArmsUpLevel";
import ScrambleLevel from "./ScrambleLevel";
import { sample, without } from "lodash";


const LEVEL_1_WORDS = ["FUSSBALLTOR", "SPRUNGBRETT","REITTURNIER","HUERDENLAUF","SIEBENKAMPF"];

const LEVEL_2_WORDS = ["TURNSCHUH","JUDOMATTE","SEGELBOOT","ZEHNKAMPF","GOLFRASEN"];

export default ({ onSetLevel, game }: any) => {
  const { t } = useTranslation("games");
  const [level, setLevel] = useState(1);
  const [started, setStarted] = useState(false);
  const [word, setWord] = useState<any>(
    sample(level === 1 ? LEVEL_1_WORDS : LEVEL_2_WORDS)
  );

  const nextWord = () => {
    setWord(
      sample(
        level === 1
          ? without(LEVEL_1_WORDS, word)
          : without(LEVEL_2_WORDS, word)
      )
    );
  };

  useEffect(() => {
    setStarted(false);
    setWord(sample(level === 1 ? LEVEL_1_WORDS : LEVEL_2_WORDS));
  }, [level]);

  const startGame = () => {
    setStarted(true);
  };

  return (
    <>
      <GameArea game={game}>
        <ScrambleLevel
          nextWord={() => nextWord()}
          word={word}
          scrambled={level === 2}
          disabled={!started}
        />
      </GameArea>

      <Content>
        <div>
          {started ? (
            <PlayButton onClick={nextWord}>Nächster Begriff</PlayButton>
          ) : (
            <PlayButton onClick={startGame} />
          )}
        </div>
        <DifficultySelector
          switchDifficulty={(level) => {
            onSetLevel(level);
            setLevel(level);
          }}
          levels={2}
          current={level}
        />
      </Content>
    </>
  );
};
